import React from 'react';
import PropTypes from 'prop-types';
import { FiEdit2, FiMail, FiPhone, FiCalendar } from 'react-icons/fi';
import './ContactInfoCard.scss';

function ContactInfoCard({ info, onEdit }) {
  const email = info?.email || '';
  const phone = info?.phone || '';
  const cc = info?.countryCode || '';
  const travelDate = info?.travelDate || '';
  const hasData = email || phone || travelDate;

  return (
    <aside className="contact-info-card">
      <header className="contact-info-card__head">
        <h3 className="contact-info-card__title">Traveler Contact Info</h3>
        <button
          type="button"
          className="contact-info-card__edit"
          onClick={onEdit}
          aria-label="Edit contact details"
        >
          <FiEdit2 />
        </button>
      </header>
      <span className="contact-info-card__title-underline" aria-hidden />

      {!hasData && (
        <p className="contact-info-card__empty">
          Add the lead passenger&apos;s contact details so we can send booking
          updates.
        </p>
      )}

      {hasData && (
        <ul className="contact-info-card__list">
          {travelDate && (
            <li className="contact-info-card__item">
              <FiCalendar />
              <div>
                <span className="contact-info-card__item-label">
                  Travel Date
                </span>
                <span className="contact-info-card__item-value">
                  {travelDate}
                </span>
              </div>
            </li>
          )}
          {email && (
            <li className="contact-info-card__item">
              <FiMail />
              <div>
                <span className="contact-info-card__item-label">Email</span>
                <span className="contact-info-card__item-value">{email}</span>
              </div>
            </li>
          )}
          {phone && (
            <li className="contact-info-card__item">
              <FiPhone />
              <div>
                <span className="contact-info-card__item-label">Mobile</span>
                <span className="contact-info-card__item-value">
                  {cc} {phone}
                </span>
              </div>
            </li>
          )}
        </ul>
      )}
    </aside>
  );
}

ContactInfoCard.propTypes = {
  info: PropTypes.shape({
    email: PropTypes.string,
    phone: PropTypes.string,
    countryCode: PropTypes.string,
    travelDate: PropTypes.string,
    returnDate: PropTypes.string,
  }),
  onEdit: PropTypes.func.isRequired,
};

ContactInfoCard.defaultProps = {
  info: null,
};

export default ContactInfoCard;
